import { Authenticator } from "@aws-amplify/ui-react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  styled,
} from "@mui/material";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import Table from "./Table";
// import "./HibiyaCafe.css";

const CLOUDFRONT_REGION = process.env.REACT_APP_CLOUDFRONT_REGION || "";
const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID || "";
const COGNITO_USER_POOL_APP_CLIENT_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_APP_CLIENT_ID || "";

Amplify.configure({
  Auth: {
    region: CLOUDFRONT_REGION,
    userPoolId: COGNITO_USER_POOL_ID,
    userPoolWebClientId: COGNITO_USER_POOL_APP_CLIENT_ID,
  },
});

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(1),
  textAlign: "center",
}));

function App() {
  return (
    <Authenticator>
      {({ signOut, user }) => (
        <Container>
          <Box sx={{ flexGrow: 1, width: "100vw" }}>
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2, display: "none" }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    position: "absolute",
                    left: "53%",
                    transform: "translateX(-53%)",
                    fontWeight: "bold",
                    flexGrow: 1,
                  }}
                >
                  CLASSMETHOD LATTE
                </Typography>
                <Button color="inherit" onClick={signOut} sx={{ marginLeft: "auto" }}>
                  Logout
                </Button>
              </Toolbar>
            </AppBar>
          </Box>
          <Table user={user} />
        </Container>
      )}
    </Authenticator>
  );
}

export default App;